import StateCard from "../sharedUi/stateCard";
import { FaUserTimes } from "react-icons/fa";
import { RiUserForbidFill } from "react-icons/ri";
import { HiMiniUserPlus } from "react-icons/hi2";
import { FaUsers } from "react-icons/fa";
import { LuBookUser } from "react-icons/lu";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { FaUserCheck } from "react-icons/fa";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { motion, AnimatePresence } from "framer-motion";


export default function UserCardsUi ({value}) {

    return(<>
        <div>
            <AnimatePresence>  
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 pb-6 pt-7 overflow-hidden"
                >
                {[ 
                    {
                    title: "No. Users",
                    value: value?.count_user,
                    subtitle: "All Analytics",
                    icon: <FaUsers className="text-white" size={18} />,
                    iconBg: "bg-purple-600"
                    },
                    {
                        title: "New Users",
                        value: value?.count_new_user?.current_total,
                        percentage: value?.count_new_user?.percentage_change,
                        direction: value?.count_new_user?.direction,
                        subtitle: "Last Month Analytics",
                        icon: <HiMiniUserPlus className="text-white" size={18} />,
                        iconBg: "bg-green-700"
                    },
                    {
                    title: "No. Block user",
                    value: value?.count_block_user,
                    subtitle: "All Analytics",
                    icon: <RiUserForbidFill className="text-white" size={18} />,
                    iconBg: "bg-red-700"
                },
                {
                    title: "No. Active User",
                    value: value?.count_active_user,
                    subtitle: "All Analytics",
                    icon: <FaUserCheck className="text-white" size={18} />,
                        iconBg: "bg-green-700"
                    },
                    {
                        title: "Suspend Users",
                        value: value?.count_suspend_user,
                        subtitle: "All Analytics",
                        icon: <FaUserTimes className="text-white" size={18} />,
                        iconBg: "bg-orange-700"
                    },
                    {
                    title: "User retention rate",
                    value: value?.count_retention_rate_user?.current_total,
                    percentage: value?.count_retention_rate_user?.percentage_change,
                    direction: value?.count_retention_rate_user?.direction,
                    subtitle: "Last Month Analytics",
                    icon: <LuBookUser className="text-white" size={18} />,
                    iconBg: "bg-blue-600"
                    }
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            </AnimatePresence>
        </div>
    </>);
};